import React, { useEffect, useState, useReducer, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
   Divider, Input, Tabs, Table, Typography, Space, Tooltip, Button, Select, Row, Col, message, Popconfirm,
   Radio, Tag, Drawer, notification, Modal, DatePicker, Upload, Form, Spin, Image
} from 'antd';
import * as AntDIcons from '@ant-design/icons';
import axios from 'axios';
import { Levels } from '../../../constants'
import Utils from '../../../misc/Utils';
import Enums from '../../../misc/Enums';
import moment from 'moment';
import './../Management.css';

const { Text } = Typography;
const { Option } = Select;

export function StudentAdd(props) {
   const [form] = Form.useForm();
   const navigate = useNavigate();

   var subdomain = localStorage.getItem("lms-subdomain");
   // const [idNumber, setIDNumber] = useState(props.studentID);

   const [updating, setUpdating] = useState(false);
   const [sectionLoading, setSectionLoading] = useState(false);
   const [levelList, setLevelList] = useState([]);
   const [sectionList, setSectionList] = useState([]);

   const [idNumber, setIDNumber] = useState(null);
   const [firstName, setFirstName] = useState(null);
   const [middleName, setMiddleName] = useState(null);
   const [lastName, setLastName] = useState(null);
   const [gender, setGender] = useState(null);
   const [birthDate, setBirthDate] = useState(null);
   const [contactNumber, setContactNumber] = useState(null);
   // const [address, setAddress] = useState(null);
   const [email, setEmail] = useState(null);
   const [lrn, setLRN] = useState(null);
   const [level, setLevel] = useState(null);
   const [section, setSection] = useState(null);
   const [isActive, setIsActive] = useState(null);
   const [pictPath, setPictPath] = useState(null);
   // const [notes, setNotes] = useState(null);
   // const [studentData, setStudentData] = useState(null);
   // const [showCredsModal, setShowCredsModal] = useState(false);
   // const [studentID, setStudentID] = useState(null);
   const [zoomAccount, setZoomAccount] = useState(null);

   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);

   const dateFormat = 'MMM. D, YYYY';
   const customFormat = value => `${value.format(dateFormat)}`;

   useEffect(() => {
      Utils.verifyJwt();

      if (user_role.toLowerCase() !== 'admin' && user_role.toLowerCase() !== 'teacher')
         navigate('/home');
   }, []);

   const handleLevelChange = (val) => {
      setSection(null)
      setLevel(val);
      setSectionLoading(true);

      axios.get(`${process.env.REACT_APP_API_LOOKUP}/sectionlistbylevel?level=${val}`).then((response) => {
         if (response.data) {
            const data = response.data;

            var sectionlist = [];
            data.map((item) => {
               let obj = { 'value': item.value, 'name': item.name }
               sectionlist.push(obj);
            });

            setSectionList(sectionlist);
            setSectionLoading(false);
         }
      }, (error) => {
         setSectionLoading(false);
         console.log(error.message);
      });
   }

   // const handleDescriptionChange = (val) => {
   //    setNotes(val);
   // }

   const handleFormValuesChange = (changedValues) => {
      const formFieldName = Object.keys(changedValues)[0];

      if (formFieldName === "level") {
         setLevel(changedValues[formFieldName]);
         form.setFieldsValue({ section: undefined });
      }
   };

   const handleCancel = () => {
      setSection(null);
      setLevel(null);
      form.resetFields();
      props.onCancelCallback();
   }

   const handleUpload = (file) => {
      const key = 'updatable';
      message.loading({ content: 'Uploading profile picture...', key, duration: 0 });

      const formData = new FormData();
      formData.append('file', file);

      var url = `${process.env.REACT_APP_API_S3_UPLOAD}/uploadMasteryFile?s3path=${process.env.REACT_APP_S3_PROFILE_PICTS}`;
      axios.post(url, formData).then(response => {
         console.log(response);
         if (response.data) {
            const data = response.data;

            // handleChange(data);
            setPictPath(data);
         }
         setTimeout(() => {
            message.success({ content: 'File upload complete!', key, duration: 2 });
         }, 1000);
      }, (error) => {
         console.log(error.message);
         setTimeout(() => {
            message.error({ content: 'File upload failed!', key, duration: 2 });
         }, 1000);
      });
   }

   const UploadPicture = () => {
      const props = {
         beforeUpload: file => {
            const isPNG = file.type === 'image/png';
            const isJPG = file.type === 'image/jpeg';
            const isBMP = file.type === 'image/bmp';

            const fileValid = isPNG || isJPG || isBMP;

            if (!fileValid) {
               Modal.error({
                  title: 'Student Management',
                  content: 'You are not allowed to upload that file type.',
                  centered: true
               });
            } else {
               handleUpload(file);
            }
         },
      };
      return (
         <Upload {...props} showUploadList={false} accept=".png,.jpg,.bmp">
            <Tooltip placement="top" title='Upload/Change profile picture'>
               <Button size="middle" shape='round' block>
                  <Text ellipsis><AntDIcons.CloudUploadOutlined />&nbsp;Upload/Change Picture</Text>
               </Button>
            </Tooltip>
         </Upload>
      );
   };

   const onFinish = (values) => {
      let StudentInfo = {
         first_name: firstName.trim(),
         middle_name: middleName !== null ? middleName.trim() : '',
         last_name: lastName.trim(),
         gender: gender,
         date_of_birth: moment(birthDate).format('YYYY-MM-DD'),
         email: email,
         id_number: idNumber !== null ? idNumber.trim() : null,
         lrn_number: lrn !== null ? lrn.trim() : null,
         mobile_number: contactNumber !== null ? contactNumber.trim() : null,
         grade_level: level,
         section: section,
         picture: pictPath,
         is_active: isActive,
         address: '',
         zoom_email: zoomAccount
      }

      const key = 'updatable';
      // message.loading({ content: 'Adding new student information...', key, duration: 0 });
      props.onUpdatingCallBack();

      var url = `${process.env.REACT_APP_API_MANAGEMENT}/addstudentinfo`;
      axios.post(url, StudentInfo).then(response => {
         console.log(response);
         if (response.data) {
            const data = response.data;
            Modal.success({
               title: 'Student Management',
               content: 'New student information added.',
               centered: true,
               onOk: () => { props.onSaveCompleteCallBack() },
            });
         }
      }, (error) => {
         console.log(error.message);
         // setTimeout(() => {
         //    message.error({ content: 'Adding new student failed!', key, duration: 2 });
         // }, 1000);
         Modal.error({
            title: 'Student Management',
            content: error.response.data,
            centered: true
         });

         props.onUpdatingFailCallBack();
      });
   }

   const onFinishFailed = (errorInfo) => {
      console.log('Failed:', errorInfo);
   };

   return (
      <>
         <Form
            form={form}
            layout={"vertical"}
            colon={false}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            onValuesChange={handleFormValuesChange}
         >
            <Row gutter={12}>
               <Col xs={24} md={5} lg={5}>
                  <Form.Item name="profile_pict" label="Picture">
                     <Space direction='vertical' size={'large'} style={{ width: '100%' }}>
                        <div className='profile_picture'>
                           <Image
                              style={{ maxHeight: '237px' }}
                              src={pictPath !== null ? `${process.env.REACT_APP_API_S3_URL}/${subdomain}/${pictPath}` : ''}
                              fallback="data:image/png;base64,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"
                           />
                        </div>

                        {UploadPicture()}
                     </Space>
                  </Form.Item>
               </Col>
               <Col xs={24} md={19} lg={19}>
                  <Row gutter={12}>
                     <Col xs={24} md={8} lg={8}>
                        <Form.Item
                           name="first_name"
                           label="First Name"
                           rules={[{
                              required: true,
                              message: 'Field required'
                           }]}
                        // initialValue={studentData.first_name}
                        >
                           <Input
                              allowClear
                              size='middle'
                              style={{ borderRadius: 7 }}
                              placeholder="Enter First Name"
                              onChange={(event) => setFirstName(event.target.value)}
                           // value={studentData.first_name}
                           />
                        </Form.Item>
                     </Col>
                     <Col xs={24} md={8} lg={8}>
                        <Form.Item
                           name="middle_name"
                           label="Middle Name"
                        // rules={[{
                        //    required: true,
                        //    message: 'Middle Name should not be blank'
                        // }]}
                        // initialValue={studentData.middle_name}
                        >
                           <Input
                              allowClear
                              size='middle'
                              style={{ borderRadius: 7 }}
                              placeholder="Enter Middle Name"
                              onChange={(event) => setMiddleName(event.target.value)}
                           // value={studentData.middle_name}
                           />
                        </Form.Item>
                     </Col>
                     <Col xs={24} md={8} lg={8}>
                        <Form.Item
                           name="last_name"
                           label="Last Name"
                           rules={[{
                              required: true,
                              message: 'Field required'
                           }]}
                        // initialValue={studentData.last_name}
                        >
                           <Input
                              allowClear
                              size='middle'
                              style={{ borderRadius: 7 }}
                              placeholder="Enter Last Name"
                              onChange={(event) => setLastName(event.target.value)}
                           // value={studentData.last_name}
                           />
                        </Form.Item>
                     </Col>

                  </Row>

                  <Row gutter={12}>
                     <Col xs={24} md={8} lg={8}>
                        <Form.Item
                           name="id_number"
                           label="ID Number"
                        // rules={[{
                        //    required: true,
                        //    message: 'Field required'
                        // }]}
                        // initialValue={studentData.id_number}
                        >
                           <Input
                              allowClear
                              size='middle'
                              style={{ borderRadius: 7 }}
                              placeholder="Enter ID Number"
                              onChange={(event) => setIDNumber(event.target.value)}
                           // value={studentData.id_number}
                           />
                        </Form.Item>
                     </Col>


                     <Col xs={24} md={8} lg={8}>
                        <Form.Item
                           name="level"
                           label="Level"
                           rules={[{
                              required: true,
                              message: 'Field required'
                           }]}
                        // initialValue={studentData.grade_level}
                        >
                           <Select
                              showArrow
                              size='middle'
                              style={{ width: '100%' }}
                              placeholder="Select Level"
                              onChange={(val) => handleLevelChange(val)}
                           // value={studentData.grade_level}
                           >
                              {Levels.map(({ value, name }, idx) => {
                                 return <Option value={value}>{name}</Option>
                              })}
                           </Select>
                        </Form.Item>
                     </Col>
                     <Col xs={24} md={8} lg={8}>
                        <Form.Item
                           name="section"
                           label="Section"
                           rules={[{
                              required: true,
                              message: 'Field required'
                           }]}
                        // initialValue={studentData.section !== '' ? studentData.section : ''}
                        >
                           <Select
                              // mode="multiple"
                              loading={sectionLoading}
                              showArrow
                              size='middle'
                              style={{ width: '100%' }}
                              placeholder="Select Section"
                              // value={studentData.section}
                              onChange={(val) => setSection(val)}
                           >
                              {sectionList.map(({ value, name }, idx) => {
                                 return <Option value={value}>{name}</Option>
                              })}
                           </Select>
                        </Form.Item>
                     </Col>
                  </Row>

                  <Row gutter={12}>
                     <Col xs={24} md={5} lg={5}>
                        <Form.Item
                           name="gender"
                           label="Gender"
                           rules={[{
                              required: true,
                              message: 'Field required'
                           }]}
                        // initialValue={studentData.gender}
                        >
                           <Select
                              showArrow
                              size='middle'
                              style={{ width: '100%' }}
                              allowClear
                              placeholder="Select Gender"
                              onChange={(val) => setGender(val)}
                           // value={studentData.gender}
                           >
                              <Option value=''></Option>
                              <Option value={'male'}>Male</Option>
                              <Option value={'female'}>Female</Option>
                           </Select>
                        </Form.Item>
                     </Col>
                     <Col xs={24} md={9} lg={9}>
                        <Form.Item
                           name="date_of_birth"
                           label="Date of Birth"
                           rules={[{
                              required: true,
                              message: 'Field required'
                           }]}
                        // initialValue={studentData.date_of_birth !== null ? moment(studentData.date_of_birth) : ''}
                        >
                           <DatePicker
                              style={{ width: "100%" }}
                              format={customFormat}
                              onBlur={(event) => setBirthDate(event.target.value)}
                           // value={moment(studentData.date_of_birth)}
                           />
                        </Form.Item>
                     </Col>

                     <Col xs={24} md={10} lg={10}>
                        <Form.Item
                           name="mobile_number"
                           label="Mobile Number"
                        // rules={[{
                        //    required: true,
                        //    message: 'LRN number should not be blank'
                        // }]}
                        // initialValue={studentData.mobile_number}
                        >
                           <Input
                              allowClear
                              size='middle'
                              style={{ borderRadius: 7 }}
                              placeholder="Enter Mobile Number"
                              onChange={(event) => setContactNumber(event.target.value)}
                           // value={studentData.mobile_number}
                           />
                        </Form.Item>
                     </Col>

                  </Row>

                  <Row gutter={12}>
                     <Col xs={24} md={10} lg={10}>
                        <Form.Item
                           name="email"
                           label="Email Address"
                        // rules={[{
                        //    required: true,
                        //    message: 'LRN number should not be blank'
                        // }]}
                        // initialValue={studentData.email}
                        >
                           <Input
                              allowClear
                              size='middle'
                              style={{ borderRadius: 7 }}
                              placeholder="Enter Email"
                              onChange={(event) => setEmail(event.target.value)}
                           // value={studentData.email}
                           />
                        </Form.Item>
                     </Col>
                     <Col xs={24} md={10} lg={10}>
                        <Form.Item
                           name="lrn_number"
                           label={<Text ellipsis >LRN (Learner Reference Number)</Text>}
                        // rules={[{
                        //    required: true,
                        //    message: 'LRN number should not be blank'
                        // }]}
                        // initialValue={studentData.lrn_number}
                        >
                           <Input
                              allowClear
                              size='middle'
                              style={{ borderRadius: 7 }}
                              placeholder="Enter LRN"
                              onChange={(event) => setLRN(event.target.value)}
                           // value={studentData.lrn_number}
                           />
                        </Form.Item>
                     </Col>
                     <Col xs={24} md={4} lg={4}>
                        <Form.Item
                           name="is_active"
                           label={<Text ellipsis >Account Active</Text>}
                           rules={[{
                              required: true,
                              message: 'Field required'
                           }]}
                        // initialValue={studentData.is_active}
                        >
                           <Select
                              showArrow
                              size='middle'
                              style={{ width: '100%' }}
                              placeholder="Select Active Status"
                              onChange={(val) => setIsActive(val)}
                           // value={studentData.is_active}
                           >
                              {/* <Option value=''></Option> */}
                              <Option value={'yes'}>Yes</Option>
                              <Option value={'no'}>No</Option>
                           </Select>
                        </Form.Item>
                     </Col>
                  </Row>
                  {
                     user_role === 'Admin' &&
                     <Row gutter={12}>
                        <Col xs={24} md={24} lg={24}>
                           <Form.Item
                              name="zoom"
                              label="Zoom Account"
                           // rules={[{
                           //    required: true,
                           //    message: 'LRN number should not be blank'
                           // }]}
                           // initialValue={studentData.email}
                           >
                              <Input
                                 allowClear
                                 size='middle'
                                 style={{ borderRadius: 7 }}
                                 placeholder="Enter Zoom Account"
                                 onChange={(event) => setZoomAccount(event.target.value)}
                              // value={studentData.email}
                              />
                           </Form.Item>
                        </Col>
                     </Row>
                  }

               </Col>
            </Row>

            <Row gutter={12}>
               <Col xs={24} md={24} lg={24} style={{ textAlign: "right" }}>
                  <Form.Item style={{ marginBottom: '0px' }}>
                     <Space direction='horizontal' size={'small'}>
                        <Button shape='round' onClick={() => { handleCancel(); }}>Cancel</Button>
                        <Button type='primary' shape='round' htmlType='submit'>Save</Button>
                     </Space>
                  </Form.Item>
               </Col>
            </Row>
         </Form>
      </>
   );
}